import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CourierRepo } from "../repositories/courier.repo";

@Injectable({
    providedIn: 'root'
})
export class MailService { 

    constructor(
        private courierRepo: CourierRepo,
    ) { }

    sendEmail(orderId: string, emailAddress: string): Observable<unknown> {
        return this.courierRepo.sendEmail(orderId, emailAddress);
    }
}  